<template>
  <div class="row newTable comfirm">
    <div class="col-md-12">
      <h5>本次將加入的成員</h5>
      <table id="customer-list" class="table datatable insurance-green">
        <thead>
          <tr>
            <th :width="Math.floor(718 * 0.17) + 'px'">
              身分
              <span class="waring-block d-inline-block ml-1">
                <span class="text">必填</span>
              </span>
            </th>
            <th :width="Math.floor(718 * 0.35) + 'px'">
              姓名
              <span class="waring-block d-inline-block ml-1">
                <span class="text">必填</span>
              </span>
            </th>
            <th :width="Math.floor(718 * 0.35) + 'px'">
              性別
              <span class="waring-block d-inline-block ml-1">
                <span class="text">必填</span>
              </span>
            </th>
            <th :width="Math.floor(718 * 0.35) + 'px'">
              生日
              <span class="waring-block d-inline-block ml-1">
                <span class="text">生日或年齡擇一必填</span>
              </span>
            </th>
            <th :width="Math.floor(718 * 0.17) + 'px'">年齡</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in selectedFamilyIn" :key="`familiy-item-${i}`">
            <td class="action-button" style="width: 180px">
              <span class="text">
                <select
                  :style="lastMember ? 'color: gray;' : ''"
                  required
                  :disabled="lastMember"
                  :class="{ 'is-invalid': errors.has(`familyrl-${i}`) }"
                  v-model="item.familyrl"
                  class="form-control form-control-inline form-short"
                >
                  <option value="" disabled>請選擇</option>
                  <option
                    v-for="(role, j) in familyRlM"
                    :value="role.role_id"
                    :key="`role-select-${j}`"
                  >
                    {{ role.role_name }}
                  </option>
                </select>
              </span>
            </td>
            <td v-if="familyrlType !== 'A'">
              <input
                :disabled="!$checkEdit(UserInfo)"
                style="width: 155px"
                :name="`name-${i}`"
                v-validate="'required'"
                alt="ch"
                :class="{ 'is-invalid': errors.has(`name-${i}`) }"
                class="form-control"
                v-model="item.name"
                v-policy.name
                @input="checkInputName(item)"
                @blur="checkInputName(item)"
              />
            </td>
            <td v-else>
              {{ item.name }}
            </td>
            <td v-if="familyrlType !== 'A'">
              <span class="text">
                <select
                  :disabled="!$checkEdit(UserInfo)"
                  style="width: 100px"
                  :name="`sex-${i}`"
                  required
                  v-validate="'required'"
                  :class="{ 'is-invalid': errors.has(`sex-${i}`) }"
                  class="form-control form-control-inline form-wide"
                  v-model="item.sex"
                >
                  <option value="" disabled>請選擇</option>
                  <option
                    v-for="(type, index) in ['男', '女']"
                    :value="type == '男' ? '1' : '2'"
                    :key="index"
                  >
                    {{ type }}
                  </option>
                </select>
              </span>
            </td>
            <td v-else>
              {{ item.sex ? (item.sex == "1" ? "男" : "女") : "— —" }}
            </td>
            <td v-if="familyrlType !== 'A'">
              <span class="d-flex">
                <!--
                <date-picker
                  :disabled="!$checkEdit(UserInfo)"
                  :placeholder="'生日'"
                  :data-vv-name="`birthday-${i}`"
                  ref="picker"
                  v-validate="{
                    required:
                      (!item.age || String(item.age).trim() === '') &&
                      item.age !== 0
                  }"
                  :disabledDates="{ from: new Date() }"
                  :input-class="{ 'is-invalid': errors.has(`birthday-${i}`) }"
                  v-model="item.birthdayROC"
                  :format="dateFormatter"
                  :language="dateLang"
                  :first-day-of-week="1"
                  :typeable="false"
                  @input="updateDateWithFormIndex(item, i)"
                />
                <div v-if="$checkEdit(UserInfo)" class="d-flex justify-content-end pickerDiv">
                  <img
                    src="../../../../../public/assets/common/icon-close-red.svg"
                    class="clearButton"
                    v-show="item.birthdayROC"
                    @click="
                      $refs.picker[i].clearDate();
                      item.birthday = '';
                    "
                  />
                </div>
                <div
                  class="d-flex justify-content-end align-items-center calendarDiv"
                  tabindex="-1"
                  @click="$refs.picker[i].showCalendar()"
                  @blur="$refs.picker[i].close()"
                >
                  <i class="icon-calendar" />
                </div>-->
                <BirthdayComponent
                  ref="birthday"
                  :itemData="item.birthdayROC"
                  :showErrText="false"
                  :validateOpen="
                    (!item.age || String(item.age).trim() === '') &&
                    item.age !== 0
                  "
                  :isBirdayError="isBirdayError[i] ? isBirdayError[i] : false"
                  @getTime="getTime($event, item, i, `birthday-${i}`)"
                />
              </span>
            </td>
            <td v-else>
              {{ item.birthday ? formatDate(item.birthday) : "— —" }}
            </td>
            <td v-if="familyrlType !== 'A' && !item.birthdayROC">
              <input
                :disabled="item.birthdayROC || !$checkEdit(UserInfo)"
                style="width: 120px"
                :name="`age-${i}`"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has(`age-${i}`) }"
                class="form-control"
                placeholder="年齡"
                v-model="item.age"
                maxlength="3"
                @input="checkInputAge(item)"
                @blur="checkInputAge(item)"            
              />
            </td>
            <td v-else-if="familyrlType !== 'A' && item.birthdayROC">
              <span class="ml-1"> {{ item.age }}</span>
            </td>
            <td v-else>
              {{ item.age ? item.age : "— —" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePicker from "@/components/DatePicker/components/Datepicker";
import { zh } from "@/components/DatePicker/locale";
import { computeAge } from "@/service/index";
import moment from "moment";
import { getFamilyrl } from "@/service/modules/mvCommon";
import BirthdayComponent from "@/desktop/components/form/BirthdayComponent";
export default {
  name: "mvAddFamilyModify",
  data() {
    return {
      selectedFamilyIn: [],
      //儲存原資料
      getAllFamilyResultOriginal: [],
      dateFormatter: (date) => {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        const y = date.getFullYear();
        if (y < 1911) {
          return `${y}/${(m < 10 ? "0" : "") + m}/${(d < 10 ? "0" : "") + d}`;
        }
        return `${y - 1911}/${(m < 10 ? "0" : "") + m}/${
          (d < 10 ? "0" : "") + d
        }`;
      },
      dateLang: zh,
      //只剩下戶長
      lastMember: false,
      familyRl: [],
      isBirdayError: [],
    };
  },
  components: {
    DatePicker,
    BirthdayComponent,
  },
  computed: {
    ...mapGetters([
      "BaseUrl",
      "FamilyResultFilter",
      "LastFamilyResult",
      "UserInfo",
    ]),
    familyRlM() {
      if (this.isMate) {
        if (this.familyrlType !== "A" && this.familyrlType !== "C") {
          return this.familyRl.filter(
            (el) => el.role_name !== "戶長" && el.role_name !== "配偶"
          );
        } else {
          return this.familyRl;
        }
        // return this.familyrlType === "A" || this.familyrlType === "C"
        // ? ["戶長", "配偶", "子女", "父母", "其他", "孫子女"]
        // : ["子女", "父母", "其他", "孫子女"];
      } else {
        if (this.familyrlType !== "A" && this.familyrlType !== "C") {
          return this.familyRl.filter((el) => el.role_name !== "戶長");
        } else {
          return this.familyRl;
        }
        // return this.familyrlType === "A" || this.familyrlType === "C"
        // ? ["戶長", "配偶", "子女", "父母", "其他", "孫子女"]
        // : ["配偶", "子女", "父母", "其他", "孫子女"];
      }
    },
  },
  props: {
    selectedFamily: {
      type: Array,
      default: () => {
        return [];
      },
    },
    familyrlType: {
      type: String,
      default: "",
    },
    isMate: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    moment,
    ...mapActions(["updateFamilyResultFilter", "updateLastFamilyResult"]),
    //檢查姓名
    checkInputName(item) {
      item.name = item.name.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(item.name, false, 50) > 50) {
        item.name = item.name.substring(
          0,
          this.stringBytes(item.name, true, 50)
        );
      }
    },
    //檢查年齡
    checkInputAge(item) {
      item.age = item.age.replace(
        /[a-zA-Z<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(item.age, false, 3) > 3) {
        item.age = item.age.substring(
          0,
          this.stringBytes(item.age, true, 3)
        );
      }
    },
    updateDateWithFormIndex(data, index) {
      //判斷生日有異動才執行年齡換算
      if (
        data.birthdayROC == this.getAllFamilyResultOriginal[index].birthdayROC
      ) {
        //點擊生日欄位後若data原先沒有birthdayROC會自動生成，故要刪除
        if (!data.birthdayROC) {
          delete data.birthdayROC;
        }
        data.age = this.getAllFamilyResultOriginal[index].age;
        return;
      }
      if (data.birthdayROC) {
        data.birthday = window.moment(data.birthdayROC).format("YYYY-MM-DD");
        computeAge(
          this.$store.state.userInfo.id,
          window.moment(data.birthdayROC).format("YYYY-MM-DD")
        ).then((result) => {
          if (result.header && result.header.status == "200") {
            data.age = result.body.age;
          } else {
            data.age = "計算錯誤";
          }
        });
        // this.$refs.age[index].disabled = true;
      } else {
        // this.$refs.age[index].disabled = false;
        data.age = "";
      }
    },
    formatDate(preDate) {
      if (preDate) {
        let dd = moment(preDate).format("YYYY-MM-DD").split("-");
        dd[0] = dd[0] - 1911;
        dd = dd.join("/");

        return dd;
      } else {
        return "";
      }
    },
    getTime(event, item, index, ageField) {
      item.birthdayROC = event.date;
      item.birthday = window.moment(event.date).format("YYYY-MM-DD");
      if (!item.age) {
        this.$set(item, "age", "");
      }
      item.age = event.age;
    },
    saveItems() {
      this.errors.clear();

      let _this = this;
      async function asyncStart() {
        let check = true;
        if(_this.$refs.birthday){
          await Promise.all(
            _this.$refs.birthday.map(async (e) =>
              (await e.validateAll()) === false ? (check = false) : ""
            )
          );
        }

        //檢核生日
        let birthdayErrorCount = 0;
         _this.isBirdayError = [];
        _this.selectedFamilyIn.map((item, index) => {
          if(item.birthdayROC && !moment(item.birthdayROC).isSameOrBefore(moment(), "day")){ 
            _this.isBirdayError.push(true);
            birthdayErrorCount++;
          }else{
           _this.isBirdayError.push(false); 
          }
        });
        if(birthdayErrorCount > 0){
          _this.$toast.info({title: "出生日期不得超過今日"});
          return false;
        }

        _this.$validator.validateAll().then((el) => {
          //配偶判斷
          let fCheck = 0;
          //戶長判斷
          let hCheck = 0;
          //全部判斷
          let rCheck = 0;
          //如為請選擇戶長判斷修改
          let bCheck = 0;
          let that = _this;
          let err = [];
          _this.selectedFamilyIn.map((item, index) => {
            if (item.familyrl == 1) {
              fCheck++;
              if (fCheck > 1) {
                for (let i = 0; i < _this.selectedFamilyIn.length; i++) {
                  if (_this.selectedFamilyIn[i].familyrl == 1) {
                    that.errors.add({
                      field: `familyrl-${i}`,
                      msg: "familyrl",
                    });
                  }
                }
                err.push("僅能有一位「配偶」，請再次確認家戶成員的身份");
                rCheck++;
              }
            }
            if (String(item.familyrl) === "0" && item.familyrl !== "") {
              hCheck++;
              if (hCheck > 1) {
                for (let i = 0; i < _this.selectedFamilyIn.length; i++) {
                  if (String(_this.selectedFamilyIn[i].familyrl) === "0") {
                    that.errors.add({
                      field: `familyrl-${i}`,
                      msg: "familyrl",
                    });
                  }
                }
                err.push("僅能有一位「戶長」，請再次確認家戶成員的身份");
                rCheck++;
              }
            }
            if (item.familyrl === "") {
              bCheck++;
              that.errors.add({
                field: `familyrl-${index}`,
                msg: "familyrl",
              });
              err.push("尚有必填欄位待確認");
              rCheck++;
            }
          });
          if (hCheck === 0 && bCheck === 0 && _this.familyrlType !== "B") {
            for (let i = 0; i < _this.selectedFamilyIn.length; i++) {
              that.errors.add({
                field: `familyrl-${i}`,
                msg: "familyrl",
              });
            }
            err.push("家戶中需有一位「戶長」，請再次確認");
            rCheck++;
          }
          if (el && rCheck === 0) {
            let chk = 0;
            let chkFamilyLeader = 0;
            if (_this.familyrlType !== "A" && _this.familyrlType !== "C") {
              _this.FamilyResultFilter.some((item) => {
                chk++;
                if (
                  item.familyrl == 0 &&
                  _this.LastFamilyResult &&
                  _this.LastFamilyResult.length > 0
                ) {
                  _this.updateFamilyResultFilter(_this.selectedFamilyIn);
                  _this.$emit("save-items-data", item.name);
                  return true;
                } else if (
                  item.familyrl == 0 &&
                  _this.LastFamilyResult &&
                  _this.LastFamilyResult.length === 0
                ) {
                  _this.updateFamilyResultFilter(_this.selectedFamilyIn);
                  _this.$emit("save-items-data", "true");
                  return true;
                } else if (
                  item.familyrl != 0 &&
                  _this.LastFamilyResult &&
                  _this.LastFamilyResult.length > 0
                ) {
                  _this.updateFamilyResultFilter(_this.selectedFamilyIn);
                  _this.$emit("save-items-data", "true");
                  return true;
                } else if (!item.familyrl) {
                  _this.updateFamilyResultFilter(_this.selectedFamilyIn);
                  _this.$emit("save-items-data", "true");
                  return true;
                }
              });
            } else {
              _this.selectedFamilyIn.forEach((item) => {
                if (item.familyrl == 0) {
                  chkFamilyLeader++;
                }
              });
            }
            if (chk > 0) {
              return false;
            } else if (
              chkFamilyLeader === 0 &&
              (_this.familyrlType === "A" || _this.familyrlType === "C")
            ) {
              for (let i = 0; i < _this.selectedFamilyIn.length; i++) {
                _this.errors.add({
                  field: `familyrl-${i}`,
                  msg: "familyrl",
                });
              }
              _this.$toast.info({
                title: "家戶中需有一位「戶長」，請再次確認",
              });
            } else if (chkFamilyLeader > 0 && _this.familyrlType === "C") {
              if (chkFamilyLeader > 1) {
                for (let i = 0; i < _this.selectedFamilyIn.length; i++) {
                  _this.errors.add({
                    field: `familyrl-${i}`,
                    msg: "familyrl",
                  });
                }
                _this.$toast.info({
                  title: "僅能有一位「戶長」，請再次確認家戶成員的身份",
                });
                _this.$emit("save-items-data", "false");
                return false;
              }
              _this.FamilyResultFilter.some((item) => {
                if (item.familyrl == 0) {
                  _this.updateFamilyResultFilter(_this.selectedFamilyIn);
                  _this.$emit("save-items-data", item.name);
                  return true;
                } else {
                  _this.updateFamilyResultFilter(_this.selectedFamilyIn);
                  _this.$emit("save-items-data", "true");
                  return true;
                }
              });
            } else {
              if (_this.familyrlType === "A") {
                if (chkFamilyLeader > 1) {
                  for (let i = 0; i < _this.selectedFamilyIn.length; i++) {
                    _this.errors.add({
                      field: `familyrl-${i}`,
                      msg: "familyrl",
                    });
                  }
                  _this.$toast.info({
                    title: "僅能有一位「戶長」，請再次確認家戶成員的身份",
                  });
                  _this.$emit("save-items-data", "false");
                  return false;
                }
                _this.updateLastFamilyResult(_this.selectedFamilyIn);
                _this.$emit("save-items-data", "true");
              } else {
                _this.updateFamilyResultFilter(_this.selectedFamilyIn);
                _this.$emit("save-items-data", "true");
              }
            }
          } else {
            for (let i = 0; i < _this.errors.items.length; i++) {
              let el = _this.errors.items[i];
              if (el.field.includes("age") || !check) {
                err.push("「生日」、「年齡」須擇一填寫");
              } else if (
                el.field.includes("name") ||
                el.field.includes("sex")
              ) {
                err.push("尚有必填欄位待確認");
              }
            }
            [...new Set(err)].forEach((item) => {
              _this.$toast.info({
                title: item,
              });
            });
            _this.$emit("save-items-data", "false");
          }
        });
      }
      asyncStart();
    },
    stringBytes(c, isSub, size) {
      //計算字元長度 (字串, 是否檢查, 檢查的長度)
      let n = c.length;
      let s;
      let len = 0;
      for (let i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
  },
  mounted() {
    //有參數傳入則取參數 無則預設取勾選人員
    if (this.selectedFamily && this.selectedFamily.length < 1) {
      if (this.familyrlType === "A") {
        this.selectedFamilyIn = window._.cloneDeep(this.LastFamilyResult);
      } else {
        this.selectedFamilyIn = window._.cloneDeep(this.FamilyResultFilter);
      }
    } else {
      this.selectedFamilyIn = this.selectedFamily;
    }
    //預設為請選擇
    if (
      this.selectedFamilyIn &&
      this.selectedFamilyIn.length > 0 &&
      this.familyrlType !== "A"
    ) {
      this.selectedFamilyIn = this.selectedFamilyIn
        .map((item) => {
          item.familyrl = "";
          if (!item.sex) {
            item.sex = "";
          }
          return item;
        })
        .map((x) => ({
          ...x,
          birthdayROC: x.birthday ? moment(x.birthday).toDate() : null,
        }));
    } else {
      //如為選擇新戶長頁面初始關係紅框
      for (let i = 0; i < this.selectedFamilyIn.length; i++) {
        this.errors.add({
          field: `familyrl-${i}`,
          msg: "familyrl",
        });
      }
      // this.$toast.info({
      //         title: "家戶中需有一位「戶長」，請再次確認",
      // });
    }
    //為選戶長頁且成員為一人
    if (
      (this.familyrlType === "A" || this.familyrlType === "C") &&
      this.selectedFamilyIn.length === 1
    ) {
      this.lastMember = true;
      this.selectedFamilyIn[0].familyrl = 0;
    }
    //依照姓名大小做排序(小 -> 大)
    this.selectedFamilyIn = this.selectedFamilyIn.sort(function (a, b) {
      return (a.name ? a.name : "").localeCompare(
        b.name ? b.name : "",
        undefined,
        {
          numeric: true,
          sensitivity: "base",
        }
      );
    });
    this.getAllFamilyResultOriginal = window._.cloneDeep(this.selectedFamilyIn);
    this.registerHanlink();
    this.familyRl = getFamilyrl();
  },
};
</script>
<style lang="scss" scoped>
.requireSpan {
  width: 47px;
  height: 20px;
  font-size: 13px;
  border-radius: 4px;
  background-color: #feeedd;
}

.waring-block {
  .text {
    height: 18px;
    font-size: 13px;
    color: #323a45;
    line-height: 13px;
    position: relative;
    padding: 3px 3px 0 12px;
  }

  .text.lg {
    flex: 1;
    width: auto;
    padding-right: 4px;
  }
  .text::before {
    position: absolute;
    content: "*";
    color: red;
    top: 6px;
    left: 6px;
  }
}

select:required:invalid {
  color: gray;
}
option[value=""][disabled] {
  display: none;
}
option {
  color: black;
}
.calendarCover {
  outline: none;
  position: relative;
  z-index: 999;
  width: 30px;
  right: 49px;
}

.clearButton {
  position: relative;
  width: 18px;
  pointer-events: auto;
}

.pickerDiv {
  position: absolute;
  padding-right: 10px;
  width: 130px;
  height: 40px;
  font-size: 22px;
  color: #f58818;
  pointer-events: none;
}

.calendarDiv {
  padding: 0 10px 0 10px;
  height: 40px;
  font-size: 24px;
  color: #f58818;
  outline: none;
}

.icon-calendar:before {
  position: relative;
  margin: 0;
  pointer-events: none;
}

span /deep/ .vdp-datepicker input {
  width: 130px;
}
</style> 